import HttpService from "../Services/HttpService";
import UpdatePlayerPairRequest from "../Requests/PlayerPairs/UpdatePlayerPairRequest";
import { groupRepository } from "./GroupRepository";
import PlayerPair from "../Models/PlayerPair";

class PlayerPairRepository
{
  public async update(playerPair: PlayerPair): Promise<void>
  {
    const url = `/PlayerPair`;
    const body: UpdatePlayerPairRequest = {
      id: playerPair.id,
      name: playerPair.name
    };
    await HttpService.put<void>(url, body);
    await groupRepository.load()
  }
}

export const playerPairRepository = new PlayerPairRepository();